<script setup>
    import { ElSelect, ElOption, ElCollapseItem } from 'element-plus';
    import { useProductStore } from '../../stores/fpe';
    import { onMounted, ref } from 'vue';
    import { storeToRefs } from 'pinia';
    import { ArrowRightBold } from '@element-plus/icons-vue'
    const store = useProductStore();
    const { product, strings, tags } = storeToRefs(store);

    const no_data_text = ref(strings.value.no_data_text);

    const searchProducts = async(query) => {
       if(query.length < 3 ){
           no_data_text.value = "Please enter 3 or more characters";
           return;
       }
       no_data_text.value = "No matching products found"; 
       store.getProducts(query);
    }

    onMounted(() => {
        if(product.value.upsell_ids.length > 0){
            store.getUpsellProductsByIds(product.value.upsell_ids);
        }

        if(product.value.cross_sell_ids.length > 0){
            store.getCrossSellProductsByIds(product.value.cross_sell_ids);
        }

        if(product.value.grouped_products.length > 0){
            store.getGroupedProductsByIds(product.value.grouped_products);
        }
    });

</script>

<template>
    <el-collapse-item :title="strings.section_title_linked_products" class="fpe-section-linked-products" name="linked_products" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="upsell-products">
            <label>{{ strings.label_upsell_products }}</label>
            
            <ElSelect
                v-model="product.upsell_ids"
                multiple
                filterable
                remote
                reserve-keyword
                :no-data-text="no_data_text"
                placeholder="Please enter a keyword"
                :remote-method="searchProducts"
                value-key="value"
            >
                <el-option 
                    v-for="(tag, id) in tags"
                    :label="tag.label"
                    :value=tag
                />
            </ElSelect> 
        </div> 
        
        <div class="fpe-field-wrapper" v-if="(product.type == 'simple' || product.type == 'variable')" data-field="cross-sell-products">
            <label>{{ strings.label_crosssell_products }}</label>
            <ElSelect
                v-model="product.cross_sell_ids"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword"
                :remote-method="searchProducts"
                value-key="value"
            >
                <el-option 
                    v-for="(tag, id) in tags"
                    :label="tag.label"
                    :value=tag
                />
            </ElSelect>
        </div>

        <div class="fpe-field-wrapper" v-if="product.type == 'grouped'" >
            <label>{{ strings.label_grouped_products }}</label>
            <ElSelect
                v-model="product.grouped_products"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword"
                :remote-method="searchProducts"
                value-key="value"
            >
                <el-option 
                    v-for="(tag, id) in tags"
                    :label="tag.label"
                    :value=tag
                />
            </ElSelect>
        </div>
    </el-collapse-item>
</template>